import Axios from "axios";
import baseStore from '../generic_store';

const base = baseStore('source-imports');

const state = {
    ...base.state,
    base_url: '/api/source-imports',
    resourceName: 'Import',
    model: {
        project_name: '',
        project_id: null,
        corporation_id: null,
        topology: 't',
        create_categories: true,
        with_brief: true,
        dry_run: false,
        prune: false,
        archive: null,
    },
};

const getters = {
    ...base.getters,
    running(state) {
        return state.list.find(item => item.status === 'pending' || item.status === 'running') || null;
    },
};

const actions = {
    ...base.actions,
    /**
     * Rafraîchit un import en cours sans repasser par la liste : le job publie son
     * avancement au fil de l'eau et la vue interroge cette ressource toutes les 2 s.
     */
    refresh({commit}, id) {
        return Axios.get('/api/source-imports/' + id)
            .then(response => {
                commit('UPDATE_ITEM', response.data.data);

                return response.data.data;
            })
            .catch(error => {
                console.warn(error);
            });
    },
    /**
     * Rejoue un import avec son archive d'origine : un échec, ou une simulation réussie qu'on
     * relance pour de bon en passant dry_run. Le serveur refuse (422) si l'archive a été libérée
     * entre-temps ou si un autre import occupe déjà le worker : le message est celui de l'API,
     * pas une reformulation.
     */
    relaunch({commit, dispatch}, {id, dry_run}) {
        return Axios.post('/api/source-imports/' + id + '/relaunch', dry_run === undefined ? {} : {dry_run})
            .then(response => {
                commit('UPDATE_ITEM', response.data.data);
                dispatch('toasts/add', {type: 'success', message: 'Import relancé'}, {root: true});

                return response.data.data;
            })
            .catch(error => {
                console.warn(error);
                dispatch('toasts/add', {
                    type: 'error',
                    // L'intercepteur global rejette avec la réponse elle-même, pas l'erreur Axios.
                    message: error?.data?.message || "La relance a échoué.",
                }, {root: true});
            });
    },
    /**
     * Remet en service la génération de plans que cet import avait remplacée. Le serveur crée une
     * ligne d'import à part : c'est elle qui devient la fiche courante, avec son journal.
     */
    restorePlans({commit, dispatch}, id) {
        return Axios.post('/api/source-imports/' + id + '/restore-plans')
            .then(response => {
                // STORE_ITEM, pas UPDATE_ITEM : la ligne est neuve. Sans elle dans state.list,
                // `currentIsListed` refermerait aussitôt la fiche que la vue vient d'ouvrir.
                commit('STORE_ITEM', response.data.data);
                dispatch('toasts/add', {type: 'success', message: 'Restauration des plans lancée'}, {root: true});

                return response.data.data;
            })
            .catch(error => {
                console.warn(error);
                dispatch('toasts/add', {
                    type: 'error',
                    message: error?.data?.message || "La restauration a échoué.",
                }, {root: true});
            });
    },
};

const mutations = {
    ...base.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
